import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Results", href: "#testimonials" },
  { label: "Location", href: "#location" },
  { label: "FAQ", href: "#faq" },
];

export default function Header({ bannerVisible = false }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      style={{ top: bannerVisible ? "40px" : "0px" }}
      className={`fixed left-0 right-0 z-40 transition-[top,background] duration-300 ${
        scrolled
          ? "bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/10"
          : "bg-gradient-to-b from-black/70 to-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between px-6 md:px-12 py-4">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <div className="w-10 h-10 border border-white/20 flex items-center justify-center">
            <span className="font-display text-xl text-[#FF3B30] leading-none">
              M
            </span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg md:text-xl tracking-wider">
              MEÑO COACHING
            </div>
            <div className="text-[10px] tracking-[0.35em] text-[#FF3B30] uppercase">
              Pushing Limits
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm tracking-widest uppercase text-white/70 hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+12089019386"
            data-testid="header-call-btn"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-bold tracking-widest uppercase text-white border border-white/20 hover:border-white px-4 py-2.5 transition"
          >
            <Phone size={14} />
            <span>(208) 901-9386</span>
          </a>
          <a
            href="#book"
            data-testid="header-book-btn"
            className="hidden lg:inline-flex btn-primary !py-2.5 !px-5 !text-xs"
          >
            Book Free Intro
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-white p-2"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-white/10 bg-[#0a0a0a]"
        >
          <div className="flex flex-col p-6 gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="text-sm tracking-widest uppercase text-white/80"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setOpen(false)}
              data-testid="mobile-book-btn"
              className="btn-primary justify-center mt-2"
            >
              Book Free Intro
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
